import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Context } from '../../..';
import styles from './CertificationInfo.module.scss';
import { Certification } from '../../../models/Certification';

const CertificationInfo: React.FC = () => {
  const { store } = useContext(Context);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [certification, setCertification] = useState<Certification | null>(null);
  console.log(id)

  useEffect(() => {
    if (id === 'new') {
      navigate('/certifications/new/edit'); // редірект на сторінку редагування нової сертифікації
      return;
    }

    const loadCertification = async () => {
      if (!store.certificationsLoaded) {
        await store.getCertifications();
      }
      const foundCertification = store.certifications.find(cert => cert.id.toString() === id);
      setCertification(foundCertification || null);
      setLoading(false);
    };

    loadCertification();
  }, [store, id, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!certification) {
    return <div className="text-center font-medium text-lg">Certification information not available.</div>;
  }

  return (
    <div className={styles['certification-info__container']}>
      <h1 className={styles['certification-info__title']}>{certification.name}</h1>
      <p className={styles['certification-info__iso']}>ISO №{certification.ISO}</p>
      {certification.photo && (
        <img src={`${process.env.REACT_APP_BASE_URL}/images/${certification.photo}`} alt={certification.name} className={styles['certification-info__image']} />
      )}
      <p className={styles['certification-info__description']}>{certification.description}</p>
      {store.user?.role === 'admin' &&
        <Link to={`/certifications/${id}/edit`} className={styles['certification-info__edit-link']}>
          Редагувати
        </Link>
      }
      <Link to={`/certifications/${certification.id}/apply`} className={styles['certification-info__submit-link']}>
        Податися на сертифікацію
      </Link>
    </div>
  );
};

export default CertificationInfo;
